<template>
  <div
    id="manning-schedule-vesels-container"
    class="manning-schedule-vesels-wrap"
  >
    <scheduler-project-model
      ref="projectmodel"
      :hasScheduleChangedAsync="SchedulerEventHandler"
      :syncSuccessAsync="syncSuccessAsync"
      :syncFailAsync="syncFailAsync"
      :loadFailAsync="loadFailAsync"
      :eventStore="VesselEventStore"
      :resourceStore="VesselResourceStore"
      :assignmentStore="VesselAssignmentStore"
      :timeRangeStore="VesselTimeRangeStore"
      :transport="transport"
    />

    <!-- スケジューラPro -->
    <bryntum-scheduler-pro
      v-if="schedulerConfig"
      v-bind="schedulerConfig"
      cls="aisea-scheduler"
      :scheduleContextFeature="scheduleContextFeature"
      :taskEditFeature="taskEditFeature"
      :eventTooltipFeature="eventTooltipFeature"
      :eventMenuFeature="eventMenuFeature"
      :eventLayout="eventLayout"
      :eventRenderer="eventRenderer"
      :tree-summary-feature="treeSummaryFeature"
      :listeners="listeners"
      :project="project"
      :tbar="tbar"
      :columns="columns"
      ref="scheduler"
    >
    </bryntum-scheduler-pro>
    <!-- 船員選択ドロワー -->
    <assignable-crews ref="assignableCrews" @crewSelected="crewSelected" />
    <manning-vessel-crew-info ref="manningVesselCrewInfo" />
  </div>
</template>
<script>
import { BryntumSchedulerPro } from "@bryntum/schedulerpro-vue";
import {
  StringHelper,
  LocaleManager,
  LocaleHelper,
  DateHelper,
} from "@bryntum/schedulerpro";
import "@bryntum/schedulerpro/locales/schedulerpro.locale.Ja.js";

import moment from "moment";

import C from "../Constants";
import transport from "./Transport";

import {
  VesselEventModel,
  VesselEventStore,
  VesselResourceStore,
  VesselAssignmentStore,
  VesselTimeRangeStore,
} from "./scheduler-stores";

import { createSchedulerConfig } from "../scheduler-config/vessel";

// マスターデータのサービス
import {
  // 船員情報マスター
  EnterpriseCrewsService,
  // 船舶情報マスター
  EnterpriseManningVesselsService,
  // 船員役割マスター
  EnterpriseCrewRoleService,
  // 配乗スコアリングカテゴリーマスター
  EnterpriseAssignmentScoringCategoriesService,
  // 船員基本条件マスター
  EnterpriseCrewsBasicConditionsService,
  // 船員配乗アラート設定サービス
  EnterpriseCrewAlertSettingsService,
  // 年度設定マスタサービス
  EnterpriseCrewsFiscalYeatDefaultsService,
  // 配乗船舶カテゴリーマスター
  ManningVesselCategoryService,
} from "../services/master";

import SchedulerEventHandler from "./SchedulerEventHandler";
import EventHelperVessel from "../scheduler-event-helper/vessel";

import SchedulerProjectModel from "../SchedulerProjectModel.vue";
import AssignableCrews from "./components/assignable-crews/AssignableCrews.vue";
import CrewsFilter from "./components/crews-filter/CrewsFilter";
import ManningVesselCrewInfo from "../components/manning-vessel-crew-info/ManningVesselCrewInfo.vue";
import { getVisibleDate } from "../utils/SchedulerUtil";
import { CustomTaskEdit } from "./components/custom-task-edit";

import Vue from "vue";

export default {
  name: "Vessels",
  components: {
    BryntumSchedulerPro,
    SchedulerProjectModel,
    AssignableCrews,
    ManningVesselCrewInfo,
  },
  data() {
    return {
      SchedulerEventHandler,
      // 現在日時
      nowDate: null,
      // スケジューラ設定
      schedulerConfig: null,
      // 入替船員未登録アラート設定 moutedでマスターから取得
      unregisterdAlertSetting: null,
      currentStartDate: null,
      currentEndDate: null,
      // Project設定
      project: null,
      transport: transport,
      // 年度選択
      selectedYear: null,
      // ヘッダーのタブバー表示設定
      tbar: null,
      // リソース列表示設定
      columns: this.buildColumns(),
      // スケジューラのイベントリスナー
      listeners: {
        beforeTaskEditShow: CustomTaskEdit.handleBeforeTaskEditShow,
        // ツリー開閉前イベント
        // ツリー開閉イベント
        toggleNode: async () => {
          await this.fillUnregisterdCrewAlertAreasAsync();
        },
        // ツリー開閉前イベント
        // こちらで、timeRangeのハイライトを解除しないとエラーになる
        beforeToggleNode: async () => {
          await this.$refs.scheduler.instance.unhighlightTimeSpans();
        },
      },
      // イベント表示設定
      eventLayout: {
        type: "stack",
        groupBy: "scheduling_status",
        weights: {
          SCHEDULED: 0,
          PLANNING: 1,
        },
      },
      // スコア表示設定
      treeSummaryFeature: {
        disabled: false,
        renderer: () => {
          const empty = "";
          return {
            text: empty,
          };
        },
      },
      // スケジューラのセル設定
      // セルをマウスオーバしたときに、「+」アイコンを表示
      // クリックした時に、船員選択ドロワーを表示
      scheduleContextFeature: {
        activateOnEvent: true,
        triggerEvent: "hover",
        widget: {
          type: "button",
          cls: "context-button b-blue b-transparent",
          icon: "b-fa b-fa-plus",
          onClick: this.cellClicked,
        },
      },
      // イベントを右クリックしたときのメニュー表示設定
      // weightはメニューの表示順
      eventMenuFeature: {
        items: {
          editVesselInfo: {
            text: "乗船情報編集",
            icon: "b-fa b-fa-ship",
            onItem: ({ eventRecord }) => {
              this.$refs.manningVesselCrewInfo.open(
                eventRecord,
                this.manningVessels,
                this.crews
              );
            },
            weight: 1,
          },
          editEvent: {
            text: "期間編集",
            icon: "b-fa b-fa-edit",
            weight: 2,
          },
          deleteEvent: {
            text: "削除",
            icon: "b-fa b-fa-trash",
            weight: 3,
            onItem: ({ eventRecord }) => {
              // イベントストアを取得
              const scheduler = this.$refs.scheduler.instance;
              const eventStore = scheduler.eventStore;

              // 予定イベントの削除は確認ダイアログを表示
              if (
                eventRecord.scheduling_status === C.SCHEDULING_STATUS.SCHEDULED
              ) {
                this.$vs.dialog({
                  type: "confirm",
                  color: "danger",
                  title: "スケジュールの削除",
                  text: "削除しますがよろしいですか",
                  cancelText: "キャンセル",
                  acceptText: "OK",
                  accept: () => {
                    // 予定イベントの削除
                    eventStore.remove(eventRecord);
                  },
                });
              } else {
                // 予定以外のイベントは確認なしで削除
                eventStore.remove(eventRecord);
              }
            },
          },
          splitEvent: false,
          cutEvent: false,
          copyEvent: false,
          unassignEvent: false,
        },
      },
      // イベントマウスオーバ時のツールチップ表示設定
      eventTooltipFeature: {
        template: data => {
          const { eventRecord } = data;
          // 注意・警戒アラートがある場合は表示
          const alerts = eventRecord.alerts;
          let alertElements = [];
          if (alerts && alerts.length > 0) {
            alertElements.push(`<h5>以下のアラートが発生しています</h5>`);
            alerts.forEach(alert => {
              alertElements.push(`<p style="font-size: 1.2rem; margin: 0;">`);
              const iconColor =
                alert.alert_type === C.EVENT_ALERT_TYPE.CAUTION
                  ? C.EVENT_ALERT_INCON_COLORS.CAUTION
                  : C.EVENT_ALERT_INCON_COLORS.WARNING;
              alertElements.push(
                `<i class="b-icon b-fa-circle-exclamation" style="color:${iconColor};"></i>`
              );
              alertElements.push(alert.message);
              alertElements.push(`</p>`);
            });
          }

          return `
                  <div class="manning-schedule-event-tooltip">
                  <h5>役職期間</h5>
                    <p>
                      ${DateHelper.format(
                        eventRecord.startDate,
                        "YYYY/MM/DD HH:mm"
                      )}
                      -
                      ${DateHelper.format(
                        eventRecord.endDate,
                        "YYYY/MM/DD HH:mm"
                      )}
                    </p>
                      ${alertElements.join("")}
                  </div>`;
        },
      },
      // イベント編集モーダル設定
      taskEditFeature: CustomTaskEdit.buildCustomTaskEdit(),
      manningVessels: [],
      crews: [],
    };
  },
  setup() {
    return {
      VesselEventStore,
      VesselResourceStore,
      VesselAssignmentStore,
      VesselTimeRangeStore,
    };
  },
  methods: {
    /**
     * スケジューラのセルクリックイベント
     */
    async cellClicked() {
      // クリックしたセルのリソースと日付を取得
      // 船員選択ドロワーに渡して、開く
      const timelineContext = this.$refs.scheduler.instance.timelineContext;
      const resourceRecord = timelineContext.resourceRecord;
      const selectedDate = timelineContext.date;
      this.$refs.assignableCrews.open(resourceRecord, selectedDate);
    },
    /**
     * 船員選択ドロワーの船員選択イベント
     * @param {Object} assignableCrews 配乗可能船員情報
     * @param {Object} resource リソース情報
     * @param {Date} date 日付
     */
    crewSelected(assignableCrews, resource, date) {
      // 基本乗船日数を取得
      // もし取得できなければ、年度デフォルト値を取得
      let basicBoardingDays = EnterpriseCrewsService.getBasicBoardingDaysByFiscalYear(
        assignableCrews.crew_id,
        this.selectedYear
      );
      if (!basicBoardingDays) {
        basicBoardingDays = EnterpriseCrewsFiscalYeatDefaultsService.getBasicBoardingDays(
          this.selectedYear
        );
      }
      // 基本乗船日数が取得できなければ、0を設定
      if (!basicBoardingDays) {
        basicBoardingDays = 0;
      }

      // イベントの開始日と終了日を設定
      const startDate = date;
      const endDate = moment(date)
        .add(basicBoardingDays, "days")
        .toDate();

      // 選択した船員でイベントモデルを作成
      // イベント編集モーダルを表示
      const scheduler = this.$refs.scheduler.instance;
      const eventStore = scheduler.eventStore;
      const eventModel = new VesselEventModel(
        {
          crew_id: assignableCrews.crew_id,
          startDate: startDate,
          endDate: endDate,
          scheduling_status: C.SCHEDULING_STATUS.PLANNING,
          phantom_group_key: `gk_${window.crypto.randomUUID()}`,
        },
        eventStore
      );
      this.$refs.scheduler.instance.editEvent(eventModel, resource);
    },
    /**
     * イベント描画設定
     * @param {Object} eventRecord イベントレコード
     * @param {Object} renderData レンダーデータ
     */
    eventRenderer({ eventRecord, renderData }) {
      // イベントの色変更
      const COLOR_LIST = ["#028AC7", "#0EA5E9"];
      const eventStore = eventRecord.eventStore;
      const records = eventStore.query(
        record =>
          record.scheduling_status === eventRecord.scheduling_status &&
          eventRecord.resourceId === record.resourceId,
        true
      );
      const idx = records.findIndex(record => record.id === eventRecord.id);

      renderData.eventColor = COLOR_LIST[idx % COLOR_LIST.length];
      renderData.style = "text-align: center;";

      // 予定、計画中でスタイルを変更
      // 計画中は透過する。
      renderData.eventStyle =
        eventRecord.scheduling_status === C.SCHEDULING_STATUS.SCHEDULED
          ? "plain"
          : "colored";

      const crew = EnterpriseCrewsService.findById(eventRecord.crew_id);
      const crewName = crew ? crew.name : "";

      // イベントに埋め込むタグ
      let eventTatgs = [
        {
          tag: "span",
          text: crewName,
        },
      ];

      // 注意・警戒アラートがある場合は、イベントにアイコンを表示
      let alerts = eventRecord.alerts;
      if (
        alerts.findIndex(
          alert => alert.alert_type === C.EVENT_ALERT_TYPE.CAUTION
        ) >= 0
      ) {
        eventTatgs.push({
          tag: "i",
          class:
            "vs-icon notranslate icon-scale material-icons small bg-small vs-icon-bg",
          text: "error",
          style: `margin-left: 0.2rem; color: ${C.EVENT_ALERT_INCON_COLORS.CAUTION};`,
        });
      }

      if (
        alerts.findIndex(
          alert => alert.alert_type === C.EVENT_ALERT_TYPE.WARNING
        ) >= 0
      ) {
        eventTatgs.push({
          tag: "i",
          class:
            "vs-icon notranslate icon-scale material-icons small bg-small vs-icon-bg",
          text: "error",
          style: `margin-left: 0.2rem; color: ${C.EVENT_ALERT_INCON_COLORS.WARNING};`,
        });
      }

      return eventTatgs;
    },
    /**
     * タブバーの設定
     * @returns {Array} タブバーの設定
     */
    buildTabbar() {
      return [
        {
          type: "label",
          text: "船舶単位 配乗表",
          style: "font-weight: bold; color: #000000;",
        },
        {
          type: "button",
          icon: "b-icon b-fa-caret-left",
          onClick: async ({ source }) => {
            this.selectedYear--;
            await this.reloadData();
            // 隣のピッカーを取得して、選択した年度を設定
            const picker = source.nextSibling;
            picker.value = this.selectedYear;
          },
        },
        {
          type: "displayfield",
          ref: "yearLabel",
          value: this.selectedYear,
          cls: "year-label",
        },
        {
          type: "button",
          icon: "b-icon b-fa-caret-right",
          onClick: async ({ source }) => {
            this.selectedYear++;
            await this.reloadData();
            // 隣のピッカーを取得して、選択した年度を設定
            const picker = source.previousSibling;
            picker.value = this.selectedYear;
          },
        },
        {
          type: "button",
          text: "更新",
          onClick: async () => {
            await this.reloadData();
          },
        },
        {
          type: "combo",
          label: "表示単位",
          width: 140,
          align: "center",
          cls: "scale-text-combo",
          editable: false,
          items: [
            { text: "日", value: "day" },
            { text: "週", value: "week" },
            { text: "月", value: "month" },
          ],
          value: "day",
          onAction: ({ value }) => this.onScaleChange(value),
        },
        "->",
        {
          type: "button",
          text: "人単位",
          onClick: () => {
            const url = this.$router.resolve({
              name: "addon-crew-assignment-management-manning-schedule-crews",
            }).href;
            window.open(url, "_blank");
          },
        },
      ];
    },
    /**
     * リソース列の設定
     * @returns {Array} リソース列の設定
     */
    buildColumns() {
      return [
        {
          type: "tree",
          text: "船名/役職",
          width: 220,
          field: "name",
          locked: true,
          htmlEncode: false,
          // リソースのヘッダーにフィルターボタンを表示
          headerWidgets: [
            {
              type: "button",
              icon: "b-fa-filter b-fa-fw",
              cls: "b-transparent",
              color: "b-gray",
              style: {
                "margin-inline-start": "auto",
              },
              onClick: ({ source }) => {
                // フィルターボタンがクリックされたときに船員フィルタモーダルを表示
                const resourceStore = this.$refs.scheduler.instance
                  .resourceStore;
                const popup = new CrewsFilter({
                  data: resourceStore.data,
                  owner: source,
                  // applyボタンがクリックされたときの処理
                  applyClicked: items => {
                    // リソースのvisibleプロパティを更新
                    items.forEach(item => {
                      const record = resourceStore.getById(item.id);
                      record.set("visible", item.visible);
                    });
                    // フィルタを適用
                    resourceStore.filter({
                      filters: resource => resource.visible,
                      replace: true,
                    });
                    // フィルターモーダルを閉じる
                    popup.destroy();
                  },
                });
                // モーダル表示
                popup.show();
              },
            },
          ],
          // 船舶情報にマウスオーバした時のみツールチップを表示する
          tooltipRenderer: renderData => {
            const { record } = renderData;
            if (!record.isLeaf) {
              // v__で始まるリソースIDから船舶IDを取得
              // 例: v__12345 -> 12345
              const vesselId = record.id.split("_")[1];
              const vessel = EnterpriseManningVesselsService.findById(vesselId);

              // 船舶名
              let vesselName = "-";
              // 船種
              let originName = "-";
              // 総トン数
              let grossTonnage = "-";
              // 機関出力数
              let enginePower = "-";
              // 自動操舵装置
              let autoPilot = "-";
              // 航行区域
              let navigationArea = "-";
              // 航行時間
              let navigationTime = "-";
              // 定員数
              let capacity = "-";

              if (vessel) {
                vesselName = vessel.name || "-";
                grossTonnage = vessel.gross_tonnage || "-";
                enginePower = vessel.engine_power || "-";
                autoPilot = vessel.auto_pilot ? "有り" : "無し";
                navigationArea =
                  EnterpriseManningVesselsService.getNavigationAreaName(
                    vessel
                  ) || "-";
                navigationTime =
                  EnterpriseManningVesselsService.getNavigationTimeName(
                    vessel
                  ) || "-";
                capacity = vessel.capacity || "-";

                const vesselCategory = ManningVesselCategoryService.findById(
                  vessel.origin_code
                );
                if (vesselCategory) {
                  originName = this.$t(
                    `Views.Crew.${vesselCategory.localized_key}`
                  );
                }
              }

              // 船舶情報のテーブルを作成
              const vesselInfoContens = [
                {
                  name: "船名",
                  value: vesselName,
                },
                {
                  name: "船種",
                  value: originName,
                },
                {
                  name: "総トン数",
                  value: grossTonnage + "総トン数",
                },
                {
                  name: "機関出力数",
                  value: enginePower + "kw",
                },
                {
                  name: "自動操舵装置",
                  value: autoPilot,
                },
                {
                  name: "航行区域",
                  value: navigationArea,
                },
                {
                  name: "航行時間",
                  value: navigationTime,
                },
                {
                  name: "定員数",
                  value: capacity + "名",
                },
              ];

              const vesselInfoElements = vesselInfoContens
                .map(item => {
                  return `<tr>
                            <td>${item.name} :</td>
                            <td style="padding: 0px 0px 0px 20px;white-space: nowrap;">${item.value}</td>
                          </tr>`;
                })
                .join("");

              const vesselInfoTable = `
                                <div style="font-weight:bold;">船舶基本情報</div>
                                <table style="border-collapse: collapse;width: auto;">
                                    ${vesselInfoElements}
                                </table>
                            `;

              return vesselInfoTable;
            }
            return "";
          },
          // リソースのセル表示カスタマイズ
          renderer: renderData => {
            const { record } = renderData;
            // 船舶の場合は、infoアイコン,下線付き青文字で表示
            if (!record.isLeaf) {
              return StringHelper.xss`
            <b style="color:blue;text-decoration:underline solid blue;">${record.name}</b>`;
            }

            return renderData.value;
          },
        },
      ];
    },

    /**
     * 入替船員未登録アラートのハイライトエリアを設定
     * @returns {Promise<void>}
     */
    async fillUnregisterdCrewAlertAreasAsync() {
      const scheduler = this.$refs.scheduler.instance;

      // 未船員配乗アラートのハイライトを設定
      const highlightTimeSpans = EventHelperVessel.createUnregisterdCrewAlertTimeSpan(
        this.project.instance,
        this.unregisterdAlertSetting,
        "highlight-caution",
        "highlight-warning",
        this.nowDate
      );

      // 警戒、注意エリア塗り設定追加
      await scheduler.highlightTimeSpans(highlightTimeSpans);
    },

    /**
     * スケジューラの同期成功時の処理
     * こちらはSchedulerProjectModelから呼び出されるイベントハンドラ
     * @returns {Promise<void>}
     */
    async syncSuccessAsync() {
      // setTimeoutが無いとサーバー同期後にハイライトが上手く反映されない。
      setTimeout(async () => {
        // アラートのハイライトエリアを再設定
        await this.fillUnregisterdCrewAlertAreasAsync();
      }, 0);
    },

    /**
     * スケジューラの同期失敗時の処理
     * こちらはSchedulerProjectModelから呼び出されるイベントハンドラ
     * @param {Object} response レスポンスオブジェクト
     */
    async syncFailAsync() {
      // 同期失敗時の処理
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "更新に失敗しました",
        text: "データを更新できませんでした。再読込みして下さい。",
        buttonCancel: true,
        acceptText: "再読込み",
        accept: () => {
          // ページをリロード
          this.reloadData();
        },
      });
    },

    /**
     * スケジューラのロード失敗時の処理
     * こちらはSchedulerProjectModelから呼び出されるイベントハンドラ
     * @param {Object} response レスポンスオブジェクト
     */
    async loadFailAsync() {
      // ロード失敗時の処理
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "システムエラー",
        text: "システムエラーが発生しました。管理者へお問い合わせください。",
        buttonCancel: true,
        acceptText: "OK",
      });
    },

    async reloadData() {
      // 既存のハイライトを解除
      // ここで解除しないとエラーになる
      await this.$refs.scheduler.instance.unhighlightTimeSpans();

      // スケジューラのデータを取得
      this.project = this.$refs.projectmodel.project;
      const projectInstance = this.project.instance;

      const res = await projectInstance.load({
        request: {
          params: {
            fiscal_year: this.selectedYear,
          },
        },
      });

      // 再ロードしてもカレンダーが変わらないので、再設定
      const { startDate, endDate } = res.response.project;
      this.currentStartDate = startDate;
      this.currentEndDate = endDate;
      await this.$refs.scheduler.instance.setTimeSpan(
        this.currentStartDate,
        this.currentEndDate
      );

      // 全リソース展開
      await this.$refs.scheduler.instance.expandAll();

      // 警戒・注意アラートをハイライト
      await this.fillUnregisterdCrewAlertAreasAsync();

      // 年度ラベルを更新
      this.$refs.scheduler.instance.widgetMap.yearLabel.value = this.selectedYear;
    },

    async onScaleChange(presetId) {
      const schedulerRef = this.$refs.scheduler;
      const scheduler = schedulerRef && schedulerRef.instance;

      let presets = [];
      if (this.schedulerConfig && Array.isArray(this.schedulerConfig.presets)) {
        presets = this.schedulerConfig.presets;
      }

      const presetExists = presets.some(function(preset) {
        return preset.id === presetId;
      });

      if (scheduler && presetExists) {
        scheduler.viewPreset = presetId;
        await this.$refs.scheduler.instance.setTimeSpan(
          this.currentStartDate,
          this.currentEndDate
        );
      } else {
        Vue.$log.warn(
          "スケジューラまたはプリセットが見つかりません",
          scheduler,
          presetId
        );
      }
    },
  },

  async mounted() {
    // スケジューラの設定を作成
    this.schedulerConfig = createSchedulerConfig();

    // 現在日時を設定
    this.nowDate = new Date();

    // スケジューラプロのローカライズ設定
    LocaleManager.locale = LocaleHelper.locales.Ja;

    // マスターデータの読み込み
    // 失敗した場合はダイアログを表示して、ページをリロードする。
    try {
      await Promise.all([
        (this.crews = await EnterpriseCrewsService.fetch()),
        (this.manningVessels = await EnterpriseManningVesselsService.fetch()),
        await EnterpriseCrewRoleService.fetch(),
        await EnterpriseAssignmentScoringCategoriesService.fetch(),
        await EnterpriseCrewsBasicConditionsService.fetch(),
        await EnterpriseCrewAlertSettingsService.fetch(),
        await EnterpriseCrewsFiscalYeatDefaultsService.fetch(),
        await ManningVesselCategoryService.fetch(),
      ]);
    } catch (e) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "システムエラー",
        text: "システムエラーが発生しました。管理者へお問い合わせください。",
        buttonCancel: true,
        acceptText: "OK",
      });
      return;
    }

    // アラートマスターから、未船員配乗アラート設定を取得
    this.unregisterdAlertSetting = EnterpriseCrewAlertSettingsService.findSettingBykind(
      C.ENTERPRISE_CREW_ALERT_KIND.REPLACEMENT_CREW_NOT_ASSIGNED
    );

    // 表示年度を設定してから、タブバーを作成
    // 初回は現在の年度を設定する。
    const fisicalYear = EnterpriseCrewsBasicConditionsService.getFiscalYear(
      this.nowDate
    );
    this.selectedYear = fisicalYear;
    this.tbar = this.buildTabbar();

    // データ読み込み
    await this.reloadData();

    // 現在時刻の線を表示
    this.project.instance.applyChangeset({
      timeRanges: {
        added: [
          {
            id: "nowDate",
            startDate: moment(this.nowDate).format(),
            cls: "b-circle",
          },
        ],
      },
    });

    // カレンダーの初期表示位置の設定
    const visibleDate = getVisibleDate(this.currentStartDate, this.nowDate, 20);
    this.$refs.scheduler.instance.visibleDate = visibleDate;
  },
};
</script>
<style lang="scss" scoped>
@import "~@bryntum/schedulerpro/schedulerpro.stockholm.css";

.manning-schedule-vesels-wrap {
  box-sizing: border-box;
  width: 100%;
  height: calc(100vh - (2.2rem * 2));
  position: relative;
}

.manning-schedule-vesels-wrap {
  :deep(.b-sch-event-content) {
    right: 0.75em !important;
    margin-left: auto !important;
  }

  /* カレンダーの土日色 */
  :deep(.calendar-saturday) {
    background-color: #b8b8ff;
    color: #fff;
  }

  :deep(.calendar-sunday) {
    background-color: #ffb8b8;
    color: #fff;
  }

  /* 現在日時線 */
  :deep(.b-grid-header .b-sch-line.b-circle.b-sch-timerange) {
    background-color: #ff0000;
    height: 0.8em !important;
    width: 0.8em !important;
    border-radius: 50%;
    margin-inline-start: -0.43em;
    bottom: 0;
    padding: 0;
  }

  :deep(.b-timeline-subgrid .b-sch-line.b-circle) {
    border-left: 2px solid #ff00003a;
  }

  /* 未船員配乗アラート 警戒・注意色 */
  :deep(.highlight-warning) {
    background-color: #f7baba;
    border: #ff00003a 1px dashed;
  }

  :deep(.highlight-caution) {
    background-color: #f5ef74;
    border: rgba(245, 236, 64, 0.341) 1px dashed;
  }

  :deep(.year-label) {
    width: 100px;
    height: 42px;
    font-size: 14px;
    color: #4f5964;
    background-color: white;
    border: rgb(208, 209, 210) solid 1px;
    border-radius: 2px;

    span {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  :deep(.scale-text-combo) {
    text-align: center;
    justify-content: center;
  }
}
</style>
